import { render, staticRenderFns } from "./oilsInvoiceNew.vue?vue&type=template&id=492b5510&scoped=true&"
import script from "./oilsInvoiceNew.vue?vue&type=script&lang=js&"
export * from "./oilsInvoiceNew.vue?vue&type=script&lang=js&"
import style0 from "./oilsInvoiceNew.vue?vue&type=style&index=0&id=492b5510&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492b5510",
  null
  
)

export default component.exports